/* icon-tile-new.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./icon-tile-new.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Tile from '@atlaskit/tile';
var sizeCrossCompatibleMap = {
  // Size mapping from old pixel sizes to new t-shirt sizes
  '16': 'xsmall',
  // Not used
  '24': 'small',
  '32': 'medium',
  '40': 'large',
  '48': 'xlarge',
  xsmall: 'xsmall',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge'
};

// Icon color mapping for Tile-based icons
var iconColorMap = {
  blue: "_syaz1ov1",
  blueBold: "_syazwdcn",
  gray: "_syaz1oju",
  grayBold: "_syaz5w2r",
  green: "_syaz17hp",
  greenBold: "_syazwdcn",
  lime: "_syaz8645",
  limeBold: "_syazwdcn",
  magenta: "_syazv8hk",
  magentaBold: "_syazwdcn",
  orange: "_syaz7r97",
  orangeBold: "_syazwdcn",
  purple: "_syaz5yjc",
  purpleBold: "_syazwdcn",
  red: "_syaznbxb",
  redBold: "_syazwdcn",
  teal: "_syaz8uof",
  tealBold: "_syazwdcn",
  yellow: "_syaz1oqg",
  yellowBold: "_syazwdcn"
};

// Background color mapping for Tile component
var backgroundColorMap = {
  blue: undefined,
  blueBold: 'color.background.accent.blue.subtle',
  gray: undefined,
  grayBold: 'color.background.neutral.bold',
  green: undefined,
  greenBold: 'color.background.accent.green.subtle',
  lime: undefined,
  limeBold: 'color.background.accent.lime.subtle',
  magenta: undefined,
  magentaBold: 'color.background.accent.magenta.subtle',
  orange: undefined,
  orangeBold: 'color.background.accent.orange.subtle',
  purple: undefined,
  purpleBold: 'color.background.accent.purple.subtle',
  red: undefined,
  redBold: 'color.background.accent.red.subtle',
  teal: undefined,
  tealBold: 'color.background.accent.teal.subtle',
  yellow: undefined,
  yellowBold: 'color.background.accent.yellow.subtle'
};

/**
 * __IconTile__
 *
 * An icon with background shape, color, and size properties determined by Tile.
 */
export default function IconTileNew(props) {
  var Icon = props.icon,
    label = props.label,
    appearance = props.appearance,
    _props$size = props.size,
    size = _props$size === void 0 ? 'small' : _props$size,
    testId = props.testId;
  var ExpandedIcon = Icon;
  return /*#__PURE__*/React.createElement(Tile, {
    size: sizeCrossCompatibleMap[size],
    backgroundColor: backgroundColorMap[appearance],
    label: label,
    testId: testId
  }, /*#__PURE__*/React.createElement("span", {
    className: ax([iconColorMap[appearance]])
  }, /*#__PURE__*/React.createElement(ExpandedIcon, {
    color: "currentColor",
    label: label,
    shouldScale: true
  })));
}